/**
 * Launch type options for tools
 */
export type LaunchType = 'LaunchTool' | 'InstallTool' | 'DownloadTool' | 'RequestAccessToTool' | 'ProvisionTool';

/**
 * Relationship type between tools
 */
export type RelationshipType = 'Recommended' | 'Alternative';

/**
 * Contact type for tool contacts
 */
export enum ContactType {
  ServiceNowBusinessOwner = 'ServiceNow Business Owner',
  ServiceNowTechnicalOwner = 'ServiceNow Technical Owner',
  ServiceNowSupportGroup = 'ServiceNow Support Group',
  SupportGroup = 'Support Group',
  Owner = 'Owner',
  SupportLink = 'Support Link',
}

/**
 * Contact types that are sourced from CMDB/ServiceNow and uneditable when serviceId exists
 */
export const CMDB_CONTACT_TYPES: readonly ContactType[] = [
  ContactType.ServiceNowBusinessOwner,
  ContactType.ServiceNowTechnicalOwner,
  ContactType.ServiceNowSupportGroup,
] as const;

/**
 * Launch type options with labels
 */
export const LAUNCH_TYPE_OPTIONS = [
  { label: 'Launch Tool', value: 'LaunchTool' },
  { label: 'Install Tool', value: 'InstallTool' },
  { label: 'Download Tool', value: 'DownloadTool' },
  { label: 'Request Access to Tool', value: 'RequestAccessToTool' },
  { label: 'Provision Tool', value: 'ProvisionTool' },
] as const;

/**
 * Relationship type options with labels
 */
export const RELATIONSHIP_TYPE_OPTIONS = [
  { label: 'Preferred', value: 'Recommended' },
  { label: 'Alternative', value: 'Alternative' },
] as const;

/**
 * Contact type options with labels (for manual/editable contacts only)
 */
export const CONTACT_TYPE_OPTIONS = [
  { label: 'Owner', value: ContactType.Owner },
  { label: 'Support Group', value: ContactType.SupportGroup },
  { label: 'Support Link', value: ContactType.SupportLink },
] as const;
